import { render, staticRenderFns } from "./CoursesSlider.vue?vue&type=template&id=be061e4e&scoped=true"
import script from "./CoursesSlider.vue?vue&type=script&lang=js"
export * from "./CoursesSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be061e4e",
  null
  
)

export default component.exports